import { ViewManager } from './ViewManager';

class ApplicationView {
  constructor({ name, url, container } = {}) {
    this.name = name || '';
    this.url = url || '';
    this.container = container || null;

    // Auto-register with ViewManager (matches ohzi-core behavior)
    if (this.name) {
      ViewManager._register(this.name, this);
    }
  }

  start() {}

  on_enter() {
    if (this.container) this.container.classList.remove('hidden');
  }

  on_exit() {
    if (this.container) this.container.classList.add('hidden');
  }

  update() {}

  update_transition() {}
}

export { ApplicationView };
